import StripString from 'helpers/strip-func'

const defaultNumberFormatOptions: Intl.NumberFormatOptions = {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}

const defaultLocale = 'en-US'

// Options are compatible with Intl.NumberFormat
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
export class CurrencyFormatter extends Intl.NumberFormat {
  constructor(
    locales: string | string[] = defaultLocale,
    options: Intl.NumberFormatOptions = {}
  ) {
    super(locales, { ...defaultNumberFormatOptions, ...options })
  }

  safeFormat(
    amount: number | string | undefined | null,
    fallback = ''
  ): string {
    if (amount === undefined || amount === null) return fallback

    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount

    if (isNaN(numAmount)) return fallback

    return this.format(numAmount)
  }
}

// @ts-ignore legacy js code
const toNum = new StripString('').currency.strip

export const currencyFormat = (data) => {
  const numData = toNum(data)
  return numData ? '$'.concat(numData) : ''
}

export default { currencyFormat }
